<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";
// import { defineAsyncComponent, ref } from "vue";
// import moment from "moment";



export default {
    page: {
        title: "Detail Tenaga Ahli",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            title: "Detail Tenaga Ahli",
            items: [
                {
                    text: "Pelaksanaan",
                    href: "/",
                },
                {
                    text: "Data Pelaksanaan",
                    href: "/pra-pelaksanaan/pembelajaran",
                },
                {
                    text: "Detail Data Pelaksanaan",
                    active: true,
                },
            ],

            id: this.$route.params.id,
            nomor_surat: null,
            kode: null,
            judul: null,
            dasar_pelaksanaan: null,
            strategi: null,
            strategi_id: null,
            durasi_he: null,
            durasi_jp: null,
            tanggal_mulai: null,
            tanggal_selesai: null,
            learning_type: null,
            angkatan: null,

            pratikum: null,
            nilai1: 90,
            nilai2: 92,
            nilai3: 95,
            nilai4: 92,
            nilai5: 91,

            inputImplementasi: {
                mahmud: { value: '3,12' },
                yura: { value: '2,33' },
                rahmah: { value: '4,21' }
            },
            inputStula: {
                mahmud: { value: '90' },
                yura: { value: '92' },
                rahmah: { value: '88' }
            },
            inputSikap: {
                mahmud: { value: '18,3' },
                yura: { value: '12,5' },
                rahmah: { value: '20,5' },
            },

            // Use in Tab Tenaga Ahli
            detailTenagaAhli: false,
            detailAspek: false,

            loadingTable: {
                tenagaAhli: true,
            },

            dataPeserta: [],
            statusNilai: 100,

            detailDataPeserta: {
                name: null,
                nip: null,
                pangkat: null,
            }
        };
    },
    mounted() {
        let self = this;
        Swal.fire({
            title: '<i class="fas fa-spinner fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
            allowOutsideClick: false,
        });

        // get data pembelajaran
        var config = {
            method: "get",
            url:
                process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pembelajaran",
            params: {
                id: self.id,
            },
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.access_token,
            },
        };
        axios(config)
            .then(function (response) {
                var response_data = response.data;
                var response_data_fix = response_data.data;
                if (response_data.meta.code == 200) {
                    var data_edit = response_data_fix.data_pembelajaran;
                    self.nomor_surat = data_edit.pbl_nomor_surat;
                    self.kode = data_edit.pbl_kode;
                    self.judul = data_edit.pbl_dasar_pelaksanaan;
                    self.dasar_pelaksanaan = data_edit.pbl_judul;
                    self.strategi = data_edit.pbl_strategi;
                    self.strategi_id = data_edit.pbl_strategi_id;
                    self.durasi_he = data_edit.pbl_durasi_he;
                    self.durasi_jp = data_edit.pbl_durasi_jp;
                    self.tanggal_mulai = data_edit.pbl_tgl_mulai;
                    self.tanggal_selesai = data_edit.pbl_tgl_selesai;
                    self.learning_type = data_edit.pbl_lt_name;
                    self.angkatan = data_edit.pbl_angkatan;

                    self.pratikum = data_edit.pbl_pratikum;

                    self.getData();

                } else {
                    Swal.close();
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: response_data_fix.data.message,
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
                Swal.close();
            });
    },
    methods: {
        getData() {
            let self = this;
            self.loadingTable.tenagaAhli = true;

            const conf = {
                url:
                    process.env.VUE_APP_BACKEND_URL_VERSION +
                    "master/peserta/getTenagaAhli",
                method: "get",
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(conf).then((response) => {
                var resStatus = response.status;
                if (resStatus == 200) {
                    self.loadingTable.tenagaAhli = false;

                    var resData = response.data.data[0];
                    self.dataPeserta = resData;
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error !',
                        text: 'Something went wrong :)',
                        showConfirmButton: true,
                    });
                }

                Swal.close();
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error !',
                    text: 'Something went wrong ! ' + error,
                    showConfirmButton: true,
                });
            });
        },

        exportTenagaAhli() {
            let self = this;

            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: 'Loading . . .',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            });

            var config = {
                method: 'get',
                url: process.env.VUE_APP_BACKEND_URL_VERSION + 'master/peserta/exportTenagaAhli',
                data: {
                    id: self.id,
                },
                crossdomain: true,
                responseType: 'blob',
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
                withCredentials: true,
            };

            axios(config).then((response) => {
                var resStatus = response.status;
                if (resStatus === 200) {
                    Swal.close();
                    // Download the file
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Data Tenaga Ahli.xlsx'); // Update filename if needed
                    document.body.appendChild(link);
                    link.click();
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Something went wrong !\n' + error,
                    showConfirmButton: true
                });
            });
        },

        showDetailTenagaAhli(index) {
            let self = this;
            self.detailTenagaAhli = true;

            self.detailDataPeserta.name = self.dataPeserta[index].name;
            self.detailDataPeserta.pangkat = self.dataPeserta[index].pangkat;

            const element = document.getElementById('cardDetailTenagaAhli');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },

        showDetailAspek(id) {
            console.log(id);
            this.detailAspek = true;
            const element = document.getElementById('tableDetailAspek');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
    },
};
</script>
<style>
/* my Style */
</style>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-12 text-end mb-3">
                        <router-link :to="`/data-pembelajaran/pra-pelaksanaan/detail/` + id" class="btn btn-danger"><i class="fa fa-arrow-left"></i> <b>Kembali</b></router-link>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                    <template v-slot:header>
                                        <h5 class="my-0 text-primary">
                                            <i class="mdi mdi-calendar-edit me-3"></i> Formulir
                                            Perencanaan Pembelajaran
                                        </h5>
                                    </template>
                                    <div class="card-body p-0">
                                        <div class="row">
                                            <div class="col-3">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Nomor Surat</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ nomor_surat }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Kode Pembelajaran</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ kode }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Dasar Pelaksanaan</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">
                                                            {{ dasar_pelaksanaan }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Judul Pembelajaran</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ judul }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Strategi</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ strategi }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Tipe Pembelajaran</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ learning_type }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">PIC</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ pic }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Angkatan</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ angkatan }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Pratikum</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ pratikum }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <h5 class="font-size-12 mb-1">
                                                                <span class="text-dark">Durasi Hari Efektif (HE)</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ durasi_he }}</p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                        <div class="col-12">
                                                            <h5 class="font-size-12 mb-1">
                                                                <span class="text-dark">Durasi Jam Pembelajaran (JP)</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ durasi_jp }}</p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <h5 class="font-size-12 mb-1">
                                                                <span class="text-dark">Tanggal Mulai</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">
                                                                {{ tanggal_mulai }}
                                                            </p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                        <div class="col-12">
                                                            <h5 class="font-size-12 font-size-12">
                                                                <span class="text-dark">Tanggal Selesai</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">
                                                                {{ tanggal_selesai }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-card>
                            </div>
                            <div class="col-12">
                                <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                    <div class="card-body p-0">
                                        <b-tabs pills justified content-class="p-3 text-muted">
                                            <b-tab>
                                                <template v-slot:title>
                                                    <span class="d-inline-block d-sm-none">
                                                        <i class="bx bx-briefcase-alt-2"></i>
                                                    </span>
                                                    <span class="d-none d-sm-inline-block" @click="showTenagaAhli()">Tenaga Ahli</span>
                                                </template>
                                                <div class="row mt-3 mb-2">
                                                    <div class="col-6">
                                                        <div class="card-title">
                                                            Data Tenaga Ahli
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="d-flex justify-content-end">
                                                            <b-button variant="info" size="sm" @click="exportTenagaAhli()">
                                                                <i class="fas fa-file-excel"></i>
                                                                &nbsp;
                                                                <b>Export Evaluasi Stula</b>
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="table-responsive">
                                                            <table class="table mb-0 mt-0 table-bordered table-condensed">
                                                                <thead class="blueTheme align-middle">
                                                                    <tr>
                                                                        <th class="text-center align-middle">No</th>
                                                                        <th class="text-center align-middle" style="min-width:20%;">Nama Tenaga<br>Pelatihan</th>
                                                                        <th class="text-center align-middle" style="min-width:20%;">NIP</th>
                                                                        <th class="text-center align-middle">Unsur Yang<br>Dinilai</th>
                                                                        <th class="text-center align-middle" style="max-width:10%;">Rata-rata<br>Penilaian<br>Peserta</th>
                                                                        <th class="text-center align-middle" style="max-width:7%;">Kualifikasi</th>
                                                                        <th class="text-center align-middle">Aksi</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr class="align-middle" v-for="(rowData, index) in dataPeserta" :key="index">
                                                                        <td class="text-center">{{ index + 1 }}</td>
                                                                        <td>{{ rowData.name }}</td>
                                                                        <td class="text-center">{{ rowData.nip }}</td>
                                                                        <td class="text-center">{{ rowData.pangkat }}</td>
                                                                        <td class="text-center">{{ statusNilai }}</td>
                                                                        <td class="text-center">
                                                                            <div class="badge badge-pill bg-badge-blue font-size-11" v-if="statusNilai >= 90">
                                                                                Sangat Baik
                                                                            </div>
                                                                            <div class="badge badge-pill bg-badge-green font-size-11" v-else-if="statusNilai >= 70">
                                                                                Baik
                                                                            </div>
                                                                            <div class="badge badge-pill bg-badge-yellow font-size-11" v-else-if="statusNilai >= 60">
                                                                                Kurang Baik
                                                                            </div>
                                                                            <div class="badge badge-pill bg-badge-red font-size-11" v-else>
                                                                                Sangat Kurang Baik
                                                                            </div>
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <b-button variant="success" size="sm" role="button" @click="showDetailTenagaAhli(index)">
                                                                                <i class="fas fa-info"></i>
                                                                                &nbsp;
                                                                                <b>Detail</b>
                                                                            </b-button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-5" id="cardDetailTenagaAhli">
                                                        <b-card header-class="bg-transparent" style="background: #eaeaea;" v-if="detailTenagaAhli == true">
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <div class="card-title mt-2 mb-3">Detail Tenaga Ahli - - -</div>
                                                                    <div class="row">
                                                                        <div class="col-md-12">
                                                                            <hr style="margin-top: 7px; margin-bottom: 7px;">
                                                                            <h6 class="mb-3"><b>Nama Tenaga Pelatihan :</b> {{ detailDataPeserta.name }}</h6>
                                                                            <h6 class="mb-4"><b>Unsur Yang Dinilai :</b> {{ detailDataPeserta.pangkat }}</h6>
                                                                        </div>
                                                                    </div>

                                                                    <table class="table mb-0 mt-0 table-bordered table-condensed">
                                                                        <thead class="blueTheme align-middle">
                                                                            <tr>
                                                                                <th class="text-center align-middle">No</th>
                                                                                <th class="text-center align-middle">Aspek</th>
                                                                                <th class="text-center align-middle">Rata-Rata Nilai</th>
                                                                                <th class="text-center align-middle">Aksi</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td class="text-center">1</td>
                                                                                <td>Penguasaan materi</td>
                                                                                <td class="text-center">79</td>
                                                                                <td class="text-center">
                                                                                    <b-button variant="success" size="sm" role="button" @click="showDetailAspek(1)">
                                                                                        <i class="fas fa-info"></i>
                                                                                        &nbsp;
                                                                                        <b>Detail</b>
                                                                                    </b-button>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="text-center">2</td>
                                                                                <td>Cara menyajikan</td>
                                                                                <td class="text-center">80</td>
                                                                                <td class="text-center">
                                                                                    <b-button variant="success" size="sm" role="button" @click="showDetailAspek(1)">
                                                                                        <i class="fas fa-info"></i>
                                                                                        &nbsp;
                                                                                        <b>Detail</b>
                                                                                    </b-button>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="text-center">3</td>
                                                                                <td>Cara menjawab pertanyaan dari peserta</td>
                                                                                <td class="text-center">88</td>
                                                                                <td class="text-center">
                                                                                    <b-button variant="success" size="sm" role="button" @click="showDetailAspek(1)">
                                                                                        <i class="fas fa-info"></i>
                                                                                        &nbsp;
                                                                                        <b>Detail</b>
                                                                                    </b-button>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="text-center">4</td>
                                                                                <td>Pemberian motivasi dan inspirasi ke peserta</td>
                                                                                <td class="text-center">90</td>
                                                                                <td class="text-center">
                                                                                    <b-button variant="success" size="sm" role="button" @click="showDetailAspek(1)">
                                                                                        <i class="fas fa-info"></i>
                                                                                        &nbsp;
                                                                                        <b>Detail</b>
                                                                                    </b-button>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="text-center"></td>
                                                                                <td><b>Total Rata-rata</b></td>
                                                                                <td class="text-center"></td>
                                                                                <td class="text-center"></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>

                                                            <div class="row mt-5" id="tableDetailAspek">
                                                                <div class="col-12">
                                                                    <div class="table-responsive" v-if="detailAspek == true">
                                                                        <div class="card-title mt-2 mb-3">Detail Aspek Penilaian - - -</div>

                                                                        <table class="table mb-0 mt-0 table-bordered table-condensed">
                                                                            <thead class="greenTheme align-middle">
                                                                                <tr>
                                                                                    <th class="text-center">No</th>
                                                                                    <th class="text-center">Nama Peserta</th>
                                                                                    <th class="text-center">Penguasaan Materi</th>
                                                                                    <th class="text-center">Cara Menyajikan</th>
                                                                                    <th class="text-center">Cara Menjawab<br>Pertanyaan dari peserta</th>
                                                                                    <th class="text-center">Pemberian Motivasi<br>dan<br>Inspirasi ke Peserta</th>
                                                                                    <th class="text-center">Rata-rata</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td class="text-center">1</td>
                                                                                    <td>Yura</td>
                                                                                    <td class="text-center">79</td>
                                                                                    <td class="text-center">79</td>
                                                                                    <td class="text-center">79</td>
                                                                                    <td class="text-center">79</td>
                                                                                    <td class="text-center">79</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td class="text-center">2</td>
                                                                                    <td>Rahmah</td>
                                                                                    <td class="text-center">79</td>
                                                                                    <td class="text-center">79</td>
                                                                                    <td class="text-center">79</td>
                                                                                    <td class="text-center">79</td>
                                                                                    <td class="text-center">79</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td class="text-center">3</td>
                                                                                    <td>Mahmud</td>
                                                                                    <td class="text-center">79</td>
                                                                                    <td class="text-center">79</td>
                                                                                    <td class="text-center">79</td>
                                                                                    <td class="text-center">79</td>
                                                                                    <td class="text-center">79</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </b-card>
                                                    </div>
                                                </div>
                                            </b-tab>
                                        </b-tabs>
                                    </div>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Popup Form Tambah Data Peserta -->
        <b-modal v-model="showFormAddPeserta" title="Form Tambah Peserta" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-add-peserta v-if="showFormAddPeserta" :idPembelajaran="id"></form-add-peserta>
        </b-modal>

        <!-- Popup Form Tambah Data Instruktur -->
        <b-modal v-model="showFormAddInstruktur" title="Form Tambah Instruktur" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-add-instruktur v-if="showFormAddInstruktur" @refresh-table="refreshTableInstruktur" :idPembelajaran="id"></form-add-instruktur>
        </b-modal>

        <!-- Popup Form Tambah Data Pratikum -->
        <b-modal v-model="showFormAddPraktikum" title="Form Tambah Praktikum" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-add-praktikum v-if="showFormAddPraktikum" @refresh-table="refreshTablePraktikum" :idPembelajaran="id"></form-add-praktikum>
        </b-modal>

        <!-- Popup Form Tambah Data Materi -->
        <b-modal v-model="showFormAddMateri" title="Form Tambah Materi" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-add-materi v-if="showFormAddMateri" @refresh-table="refreshTableMateri" :idPembelajaran="id"></form-add-materi>
        </b-modal>

        <!-- Popup Form Edit Data Materi -->
        <b-modal v-model="showFormEditMateri" title="Form Ubah Materi Master" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-edit-materi v-if="showFormEditMateri" @refresh-table="refreshTableMateri" :idData="idMateri"></form-edit-materi>
        </b-modal>

        <!-- Popup Form Tambah Data Akomodasi -->
        <b-modal v-model="showFormAddAkomodasi" title="Form Tambah Akomodasi" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-add-akomodasi v-if="showFormAddAkomodasi" @refresh-table="refreshTableAkomodasi" :idPembelajaran="id" :strategiId="strategi_id"></form-add-akomodasi>
        </b-modal>

        <!-- Popup Form Detail Praktikum -->
        <b-modal v-model="showFormDetailPraktikum" title="Detail Praktikum" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <detail-praktikum v-if="showFormDetailPraktikum" @refresh-table="refreshTablePraktikum" :idPraktikum="idPraktikumSelected" :idPembelajaran="id"></detail-praktikum>
        </b-modal>

        <!-- Popup Form Unggah Undangan Peserta -->
        <b-modal v-model="showFormUnggahUndangan" title="Formulir Unggah Undangan Peserta" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-unggah-undangan v-if="showFormUnggahUndangan" @close-form-undangan="closeFormUndangan" :statusUnggahUndangan="status_unggah_undangan" :idPembelajaran="id"></form-unggah-undangan>
        </b-modal>

        <!-- Popup Form Absensi Peserta -->
        <b-modal v-model="showFormAbsensiPeserta" title="Absensi Peserta" title-class="text-black font-18" body-class="p-3" size="xl" hide-footer>
            <absensi-peserta v-if="showFormAbsensiPeserta" @close-form-absensi-peserta="closeFormAbsensiPeserta" :idPembelajaran="id"></absensi-peserta>
        </b-modal>

        <!-- Popup Form Absensi Instruktur -->
        <b-modal v-model="showFormAbsensiInstruktur" title="Absensi Instruktur" title-class="text-black font-18" body-class="p-3" size="xl" hide-footer>
            <absensi-instruktur v-if="showFormAbsensiInstruktur" @close-form-absensi-instruktur="closeFormAbsensiInstruktur" :idPembelajaran="id"></absensi-instruktur>
        </b-modal>

        <!-- Popup Form Absensi Instruktur -->
        <b-modal v-model="showFormTemplateSurat" title="Template Surat Pemanggilan" title-class="text-black font-18" body-class="p-3" size="xl" hide-footer>
            <template-surat-pemanggilan v-if="showFormTemplateSurat" :idPembelajaran="id" :strategiId="strategi_id" :tipeSurat="tipeSuratPemanggilan"></template-surat-pemanggilan>
        </b-modal>

        <!-- Popup Feedback Peserta -->
        <b-modal v-model="showFeedbackPeserta" title="Feedback Peserta" title-class="text-black font-18" body-class="p-3" size="xl" hide-footer>
            <b-form class="p-2" @submit.prevent="updateFeedback">
                <div class="form-group">
                    <label for="">Isi</label>
                    <textarea name="" class="form-control" v-model="feedback_peserta_temp" id="" cols="30" rows="10"></textarea>
                </div>
                <hr />
                <div class="row">
                    <div class="col text-end">
                        <button type="submit" class="btn btn-success">Simpan</button>
                    </div>
                </div>
            </b-form>
        </b-modal>
        <!-- Popup List Kamar -->
        <b-modal v-model="showKamar" title="List Kamar" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <room-akomodasi v-if="showFormKamar" :idPembelajaran="id"></room-akomodasi>
        </b-modal>
    </Layout>

    <b-modal v-model="setupModalAdd" id="modal-2" hide-footer title="Tambah Tahapan" size="lg" @hidden="closeModalStagesAdd">
        <b-form-group label="Pilih Tahapan" label-for="selectStagesAdd">
            <select class="form-select mb-3" id="selectStagesAdd" v-model="selectStageAdd" @change.prevent="selectStagesAdd()">
                <option value="">-- Pilih Tahapan --</option>
                <option v-for="(row, index) in optionStage" :value="row.value" :key="index">{{ row.text }}</option>
            </select>
        </b-form-group>

        <b-form @submit.prevent="storeDataStages">
            <template v-if="selectStageAdd == ''">
                <div class="row">
                    <div class="col-md-12">
                        <h5 class="text-center">-- Pilih Tahapan Terlebih Dahulu --</h5>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="container-fluid" style="background: #e9ebf7; border-radius: 10px; padding: 10px 8px;">
                    <div class="row">
                        <div class="col-md-12">
                            <b-form-group class="mb-3" label="Judul Agenda" label-for="titleAgendaAdd">
                                <b-form-input id="titleAgendaAdd" placeholder="Masukkan Judul Agenda..." type="text" v-model="titleAgendaAdd">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group class="mb-3" label="Tipe Agenda" label-for="typeAgendaAdd">
                                <b-form-select id="typeAgendaAdd" v-model="typeAgendaAdd">
                                    <b-form-select-option value="">-- Pilih Tipe --</b-form-select-option>
                                    <b-form-select-option value="virtual">Virtual</b-form-select-option>
                                    <b-form-select-option value="on_site">On-Site</b-form-select-option>
                                </b-form-select>
                            </b-form-group>

                            <b-form-group class="mb-3" label="Jam Pembelajaran" label-for="durationAgendaAdd">
                                <b-form-input id="durationAgendaAdd" v-model="durationAgendaAdd" placeholder="Masukkan Durasi Agenda..." type="number">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group class="mb-3" label="Keterangan" label-for="detailAgendaAdd">
                                <textarea class="form-control" id="detailAgendaAdd" v-model="detailAgendaAdd" placeholder="Keterangan Agenda . . ." cols="30" rows="7" style="resize:none;"></textarea>
                            </b-form-group>

                            <b-form-group class="mb-3" label="Link Zoom" label-for="linkAgendaAdd">
                                <b-form-input id="linkAgendaAdd" v-model="linkAgendaAdd" placeholder="http://. . . . ." type="url">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group class="mb-3" label="Link File Materi" label-for="linkFileAdd">
                                <b-form-input id="linkFileAdd" v-model="linkFileAdd" placeholder="http://. . . . ." type="url">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group class="mb-3" label="Video Materi" label-for="linkVideoAdd">
                                <b-form-input id="linkVideoAdd" v-model="linkVideoAdd" placeholder="http://. . . . ." type="url">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group label="Apakah upload tugas ?">
                                <div>
                                    <b-form-radio class="d-inline-block" v-model="questionUploadAdd" name="questionUploadAdd" value="yes">
                                        Yes
                                    </b-form-radio>
                                    &nbsp;
                                    <b-form-radio class="d-inline-block" v-model="questionUploadAdd" name="questionUploadAdd" value="no">
                                        No
                                    </b-form-radio>
                                </div>
                            </b-form-group>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <hr style="background:grey; height: 2px; border-radius: 25%;">
                        </div>
                        <div class="col-md-12 text-end">
                            <b-button type="reset" variant="danger" @click.prevent="confirmResetFormStagesAdd()">
                                <i class="fas fa-redo-alt"></i> <b>Reset</b>
                            </b-button>
                            &nbsp;
                            <b-button type="sumbit" variant="success" @click="console.log('test')">
                                <i class="fas fa-check"></i> <b>Simpan</b>
                            </b-button>
                        </div>
                    </div>
                </div>
            </template>
        </b-form>
    </b-modal>
</template>
